import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'ziro-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent implements OnInit, OnDestroy {
  private breadcrumbsService = inject(BreadcrumbsService);

  ngOnInit(): void {
    this.breadcrumbsService.updateBreadcrumbs([{ label: 'tkey;menu.report.dashboard' }]);
  }

  ngOnDestroy(): void {
    this.breadcrumbsService.clearBreadcrumbs();
  }
}
